export default __webpack_public_path__ + "static/m-fitness1-5873624b1137e0fe702d3e2377e528dc.jpg";